import scheduleChangeRefetch from '../scheduleChangeRefetch';

export default function buildRefetchQueries({
  event: { dealerId, blockStart },
}) {
  return () => scheduleChangeRefetch(blockStart, dealerId);
}



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/RotationSchedulePanel/RotationDeleteModal/buildRefetchQueries.js